/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { clip, mj_return_false } from './util.js';
import { getFromSession, setInSession } from './session-util.js';
import { $ } from '../other/jquery-hooked.js';

import { setupTooltips } from './page-tooltips.js';

import {
	MVPage_init1,
	MVPage_init2,
	MVPage_trigger_winresize
} from './page-util.js';

import { mjt } from './i18ntexts.js';

import './responsive-menu.js';


// import { MVNotifications } from './notifications-view.js';


/**
 * initialize essential page utils
 * - usually called once when DOM is ready.
 */
export function initMVAppPage() {
	return actuallyInitMVAppPage();
}



// config for jquery.ui.touch-punch.js
window.touchPunchDelay = 163;

window.onTouchPunchLongPressAccepted = function( event ) {
	//event.originalEvent.touches
	if( 'vibrate' in navigator ) navigator.vibrate(150);
};


/**
 * initialize essential page utils
 * usually called once when DOM is ready
 *  - this code is a mess
 *  - refactoring required!
 */
function actuallyInitMVAppPage() {

	MVPage_init1();

	// disable interaction with 'page-blocking-overlay'
	var pbo = $('#page-blocking-overlay');
	pbo.on( 'contextmenu', mj_return_false );
	pbo[0].ondrag = mj_return_false;
	pbo[0].ondragstart = mj_return_false;
	pbo[0].onselectstart = mj_return_false;
	// pbo = null; // release reference

	// init some common page elements
	$('#info').click( function() {
		$(this).stop(true).slideUp(200);
		return false;
	} );

	// add splitter between left & right page sides
	var page_left=$('#page-left'),
		page_left_band=$('#page-left-band'),
		page_right=$('#page-right'),
		page_left_last_resizable_stop_ts=null,
		_prev_page_left_zindex = null,
		_prev_page_left_band_state = null;

	function _update_page_left_splitter_ui( force_update, trigger_winresize ) {
		var page_left_zindex = page_left.css('zIndex');
		var page_left_band_state = page_left_band.css('display')==='none' ? 0 : ( page_left_band.hasClass('closed') ? 1 : 2 );
		if( force_update || page_left_zindex!==_prev_page_left_zindex || page_left_band_state!==_prev_page_left_band_state ) {
			_prev_page_left_zindex = page_left_zindex;
			_prev_page_left_band_state = page_left_band_state;
			var plw = Math.floor(page_left.width()||0);
			page_right.css('left',(plw+2)+'px');
			if( page_left_zindex==='auto' ) {
				// page_left is hidden ...
				page_left_band
					.css({left:'0px',position:''})
					.addClass('closed');
				page_left
					.children('div.ui-resizable-e').addClass('closed');
				page_left.addClass('closed');
			} else {
				// page_left is shown
				page_left_band
					.removeClass('closed')
					.css({left:plw+'px',position:''});
				page_left
					.css({width:plw+'px',height:''})
					.children('div.ui-resizable-e').removeClass('closed');
				page_left.removeClass('closed');
			}
			if( trigger_winresize ) {
				// trigger global 'mjswinresize' event - this should trigger an update and re-arrangement of all views
				MVPage_trigger_winresize();
			}
		}
	}

	if( page_left.length && page_right.length ) {
		var elw = page_left.width()||0;
		var plw_min=240, plw_max=550;
		if( elw > plw_max ) elw = plw_max; // hard limit
		var page_left_width = parseInt( getFromSession('page_left_width',elw), 10 );
		page_right.css('left',(page_left_width+2)+'px');
		page_left
			.css('width',page_left_width+'px')
			.resizable( {
				handles:'e',
				minWidth:plw_min,
				maxWidth:plw_max,
				start: function( evt, ui ) {
					$('.ctx-menu:visible').parent('div').hide();
					if( !page_left_band.hasClass('closed') ) page_left_band.addClass('ui-draggable-dragging');
				},
				resize: function( evt, ui ) {
					_update_page_left_splitter_ui(true,true);
				},
				stop: function( evt, ui ) {
					// save width in session
					page_left_band.removeClass('ui-draggable-dragging');
					page_left_last_resizable_stop_ts = evt.timeStamp;
					setInSession('page_left_width',Math.floor(page_left.width()||0));
				},
			} )
			.children('div.ui-resizable-e')
			.on('click',function(e) {
				if( e.timeStamp - (page_left_last_resizable_stop_ts||0) > 200 ) {
					if( page_left_band.is(':visible') && !page_left_band.hasClass('closed') ) {
						page_left_band.triggerHandler('click');
						return false;
					}
				}
			});
		page_left_band
			.draggable( {
				axis: 'x',
				containment: 'parent',
				cursor: 'col-resize',
				start: function( evt, ui ) {
					page_left.addClass('ui-resizable-resizing');
				},
				drag: function( evt, ui ) {
					if( page_left_band.hasClass('closed') ) {
						ui.position.left = 0;
					} else {
						ui.position.left = clip(ui.position.left,plw_min,plw_max);
						page_left.css('width',Math.floor(ui.position.left)+'px');
						_update_page_left_splitter_ui(true,true);
					}
				},
				stop: function( evt, ui ) {
					page_left.removeClass('ui-resizable-resizing');
				},
			} )
			.on('click',function() {
				// click handler for page-left-band (for small screens)
				page_left.css( 'zIndex', page_left_band.hasClass('closed') ? 5 : '' ); // show/hide page_left
				_update_page_left_splitter_ui(true,true);
			} )
			.on('contextmenu',mj_return_false);
		if( page_left_band && page_left_band[0] ) page_left_band[0].onselectstart = mj_return_false;
		_update_page_left_splitter_ui();
	}



	function isValidDataTransfer( dataTransferRef ) {
		let validDatatransfer = false;
		if( dataTransferRef!==null && dataTransferRef.types.length ) {	//( dataTransferRef.types.length===1 || dataTransferRef.types.length===2 ) ) {
			validDatatransfer = $.inArray('Files',dataTransferRef.types) !== -1;
		}
		if( !validDatatransfer && dataTransferRef!==null ) {
			for( const transferItem of dataTransferRef.items ) {
				const transferItemEntry = transferItem.webkitGetAsEntry ? transferItem.webkitGetAsEntry() : ( transferItem.getAsEntry ? transferItem.getAsEntry() : null );
				if( transferItemEntry ) {
					return true;
				}
			}
		}
		return validDatatransfer;
	}


	// MVDrop init ...
	$(document)
		.on('dragenter', function(e) {
			const dataTransferRef = e.originalEvent.dataTransfer ?? null;
			if( window.MVUpload && window.MVUpload.getOpenState()==='opened' && isValidDataTransfer(dataTransferRef) ) {
				dataTransferRef.dropEffect = 'copy';
				// show drag/drop overlay - note: further "drag*" events will bind on this div...
				$('#page-drag-overlay').css('display','block').attr('data-responsible-module','MVUpload');
			} else if( window.MVDrop && isValidDataTransfer(dataTransferRef) ) {
				dataTransferRef.dropEffect = 'copy';
				// show drag/drop overlay - note: further "drag*" events will bind on this div...
				$('#page-drag-overlay').css('display','block').attr('data-responsible-module','MVDrop');
			}
		} );

	if( window.MVDrop && window.MVUpload ) {
		window.MVDrop.init();
	}



	$(document)
		.on( 'mjswinresize', $.debounce( 75, function(e,w,h,fs) {
			_update_page_left_splitter_ui();
			$('#page-menu-2').mjResponsiveMenu('update');
		} ) );

	$('#page-menu-2').mjResponsiveMenu( {
		buttonText: mjt('responsive-menu-button')
	} );

	setupTooltips();

	MVPage_init2();

	/*** temporarily disabled:
	// init notifications view
	if( MVNotifications ) {
		const $appendToElem  = $('#page-menu-1');
		MVNotifications.init( $appendToElem, function( notificationViewsLoaded ) {
			if( notificationViewsLoaded ) {
				// quick hack: TODO: evaluate better events and hooks ...
				window.onbeforeunload = function( e ) {
					// when we unload, we must STOP notification polling
					// (it could conflict with changing session etc..)
					if( MVNotifications ) MVNotifications.shutdown();
				};
			}
		} );
	}
	***/

	// trigger hash change event once on page load
	$(window).trigger('hashchange');
}

